import { Outlet } from "react-router-dom";
import SideBar from "./Components/Sidebar/Sidebar.jsx";

export default function ProtectedLayout({ onLogout }) {
  return (
    <div className="app-shell">
      <SideBar onLogout={onLogout} />
      {/* This is where your matched page renders */}
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
